var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PrePurchasedAssignCard',{staticClass:"pa-0",attrs:{"value":_vm.value,"flat":"","readonly":"","hide-title":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }